import { render, staticRenderFns } from "./MemberPersonal.vue?vue&type=template&id=6f5fcfcc"
import script from "./MemberPersonal.vue?vue&type=script&lang=js"
export * from "./MemberPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports